import { Button } from "@/components/ui/button.tsx";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip.tsx";
import { useCallback, useState } from "react";
import type { ActionBarAction, ActionBarProps } from "./types.ts";

interface ActionItemProps extends ActionBarAction {
  props: ActionBarProps;
}

export const ActionItem = ({
  onClick,
  autoClear,
  activatedIcon,
  icon,
  props,
  tooltip,
  id,
}: ActionItemProps) => {
  const [isActivated, setIsActivated] = useState(false);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.preventDefault();
      e.stopPropagation();
      onClick?.(props);
      if (autoClear) {
        setIsActivated(true);
        setTimeout(() => {
          setIsActivated(false);
        }, 2000);
      }
    },
    [onClick, autoClear, props],
  );

  const Icon = isActivated && activatedIcon ? activatedIcon : icon;

  return (
    <div className="text-xs text-muted-foreground">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            onClick={handleClick}
            size="fit"
            variant="ghost"
            className="size-5"
            data-statsig-name={`action-bar-${id}`}
          >
            <Icon className="size-3" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">{tooltip}</TooltipContent>
      </Tooltip>
    </div>
  );
};
